<div class="balance-container">
  <h3>Balansım</h3>
  <div class="balance-card">
    <div class="balance-info">
      <span class="label">Pulsuz Elan Krediti Balansı</span>
      <span class="amount">{{balance.amount}} elan</span>
      <span class="expiry">Bitmə tarixi: {{balance.expiryDate}}</span>
    </div>
    <button class="btn-buy" (click)="showModal = true">Balans al</button>
  </div>

  <div class="packages-section" *ngIf="showModal">
    <div class="modal-overlay" (click)="showModal = false"></div>
    <div class="modal-content">
      <h4>Paket seçimi</h4>
      <div class="packages-list">
        <div class="package-item" *ngFor="let pkg of packages" [class.selected]="selectedPackage?.id === pkg.id" (click)="selectedPackage = pkg">
          <div class="pkg-name">{{pkg.name}}</div>
          <div class="pkg-price">{{pkg.price}} ₼</div>
          <div class="pkg-details">{{pkg.count}} elan / {{pkg.duration}} gün</div>
        </div>
      </div>
      <div class="total-section" *ngIf="selectedPackage">
        <span>Cəmi:</span>
        <span class="total-price">{{selectedPackage.price}} ₼</span>
      </div>
      <button class="btn-pay" [disabled]="!selectedPackage" (click)="pay()">Ödə</button>
    </div>
  </div>
</div>
